import { Link } from 'react-router-dom';
import { Post } from '../../../lib/supabase';
import { categories } from '../../../data/categories';

function formatDate(dateStr: string) {
  const d = new Date(dateStr);
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
}

const mockArticles: Post[] = [
  {
    id: 'm1', slug: 'cursor-composer-tips-2026',
    title: 'Cursor Composerで長い実装を分割する方法——コンテキスト切れを防ぐ3つの工夫',
    excerpt: '長い実装をAIに任せると途中でコンテキストが切れる。その対策として試した分割戦略を整理した。',
    category_slug: 'ai-creation', published_at: '2026-04-01',
    tags: ['Cursor', 'AI'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm2', slug: 'spec-driven-development-intro',
    title: '仕様書ファーストで開発する——AIに「何を作るか」を先に伝える設計',
    excerpt: 'コードを書く前に仕様書を作ると、AIとのやり取りが劇的に変わる。その具体的な手順と効果。',
    category_slug: 'build-log', published_at: '2026-03-25',
    tags: ['仕様書', '制作フロー'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm3', slug: 'claude-vs-chatgpt-coding',
    title: 'ClaudeとChatGPTをコーディングで使い比べた——得意・不得意の違いが見えてきた',
    excerpt: '同じタスクを両方に投げて比較した。どちらが何に向いているか、実感ベースでまとめる。',
    category_slug: 'productivity', published_at: '2026-03-18',
    tags: ['Claude', 'ChatGPT', '比較'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm4', slug: 'prompt-template-for-ui',
    title: 'UIコンポーネントを作るときのプロンプトテンプレートを公開する',
    excerpt: '何度も使い回せるプロンプトの型を作った。Reactコンポーネント生成に特化したバージョン。',
    category_slug: 'productivity', published_at: '2026-03-10',
    tags: ['プロンプト', 'React'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm5', slug: 'ui-reproduction-spotify-log',
    title: 'Spotify風UIをゼロから再現する——詰まったところと解決策の全記録',
    excerpt: 'デザインを見て「これ作れそう」と思ったが、実際には何度も詰まった。その過程をそのまま残す。',
    category_slug: 'ai-creation', published_at: '2026-03-12',
    tags: ['UI再現', 'Spotify'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm6', slug: 'readdy-site-week1-log',
    title: 'Readdy.aiでブログを作った最初の7日間——判断・迷い・失敗の全記録',
    excerpt: 'ゼロからサイトを立ち上げた1週間。何を決めて、何で詰まって、どう解決したかを全部書く。',
    category_slug: 'build-log', published_at: '2026-03-05',
    tags: ['Readdy', 'サイト制作'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm7', slug: 'ai-article-writing-flow',
    title: 'AI記事制作フローを仕様化する——プロンプト設計から構成・校正まで',
    excerpt: '記事を書くプロセス自体をAIで効率化・仕様化する試み。一気通貫で整理した。',
    category_slug: 'build-log', published_at: '2026-02-28',
    tags: ['記事制作', 'プロンプト'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
  {
    id: 'm8', slug: 'notion-like-ui-with-ai',
    title: 'NotionライクなUIをAIだけで作る——ブロックエディタの設計と実装ログ',
    excerpt: 'ブロックエディタの仕組みを理解しながら、AIと一緒に実装した記録。設計の考え方も残す。',
    category_slug: 'ai-creation', published_at: '2026-02-20',
    tags: ['Notion', 'UI再現', 'エディタ'], featured: false, image_url: '', author_name: '', updated_at: '', created_at: '', content: '', image_map: null,
  },
];

interface PostsListProps {
  posts: Post[];
  activeCategory: string;
  loading: boolean;
  onCategoryChange: (slug: string) => void;
}

export function PostsList({ posts, activeCategory, loading, onCategoryChange }: PostsListProps) {
  const displayPosts = posts.length > 0 ? posts : mockArticles;
  const filtered = activeCategory === 'all'
    ? displayPosts
    : displayPosts.filter((p) => p.category_slug === activeCategory);

  if (loading) {
    return (
      <div className="py-20 text-center">
        <i className="ri-loader-4-line text-3xl text-[#9A8E84] animate-spin block mb-3"></i>
        <p className="text-sm text-[#9A8E84]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          読み込み中...
        </p>
      </div>
    );
  }

  if (filtered.length === 0) {
    return (
      <div className="py-16 text-center">
        <p className="text-sm text-[#9A8E84] mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          このカテゴリの記事はまだありません
        </p>
        <button
          onClick={() => onCategoryChange('all')}
          className="text-xs text-[#5B7B6F] hover:text-[#2C2416] transition-colors cursor-pointer"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          すべての記事を見る
        </button>
      </div>
    );
  }

  return (
    <div className="divide-y divide-[#EDE7DF]">
      {filtered.map((post) => {
        const cat = categories.find((c) => c.slug === post.category_slug);
        return (
          <article key={post.id}>
            <Link
              to={`/articles/${post.slug}`}
              className="flex items-start gap-4 py-5 group cursor-pointer"
            >
              {/* Thumbnail */}
              {post.image_url ? (
                <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md overflow-hidden bg-[#F0EBE3]">
                  <img
                    src={post.image_url}
                    alt={post.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md bg-[#F0EBE3] flex items-center justify-center">
                  <i className="ri-article-line text-xl text-[#C8BFB5]"></i>
                </div>
              )}

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  {cat && (
                    <span
                      className="text-xs text-[#5B7B6F] font-medium"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {cat.name}
                    </span>
                  )}
                  <span className="text-[#D4C9BE] text-xs">·</span>
                  <span
                    className="text-xs text-[#9A8E84]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {formatDate(post.published_at)}
                  </span>
                  {post.featured && (
                    <>
                      <span className="text-[#D4C9BE] text-xs">·</span>
                      <span
                        className="text-[10px] font-semibold text-[#5B7B6F] bg-[#EEF4F2] px-1.5 py-0.5 rounded"
                        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                      >
                        おすすめ
                      </span>
                    </>
                  )}
                </div>
                <h2
                  className="text-sm sm:text-base font-semibold text-[#2C2416] leading-snug mb-1.5 group-hover:text-[#5B7B6F] transition-colors"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {post.title}
                </h2>
                {post.excerpt && (
                  <p
                    className="text-xs text-[#7A6E62] leading-relaxed line-clamp-2"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {post.excerpt}
                  </p>
                )}
              </div>
            </Link>
          </article>
        );
      })}
    </div>
  );
}
